var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
let Tips = class Tips extends BaseComponent {
    constructor() {
        super(...arguments);
        this.tips = '';
    }
    render() {
        return html `
      <div class='bg-tip-box w-full rounded-lg text-left p-16'>
        <p>
          ${this.tips}
        </p>
      </div>
    `;
    }
};
__decorate([
    property()
], Tips.prototype, "tips", void 0);
Tips = __decorate([
    customElement('trust-feedback-tips')
], Tips);
export { Tips };
//# sourceMappingURL=Tips.js.map